import React from "react";
import "./index.scss";
export default function Title({ text }) {
  return (
    <div className="title_con">
      <div className="title"> {text}</div>
      <div className="title_bar"></div>
    </div>
  );
}
